import React from 'react';
interface InputProps {
  label: string;
  type?: 'text' | 'email' | 'tel' | 'number';
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  required?: boolean;
  prefix?: string;
  className?: string;
}
export function Input({
  label,
  type = 'text',
  placeholder,
  value,
  onChange,
  error,
  required = false,
  prefix,
  className = ''
}: InputProps) {
  const id = `input-${label.toLowerCase().replace(/\s+/g, '-')}`;
  return <div className={`flex flex-col ${className}`} data-id="element-226">
      <label htmlFor={id} className="text-sm font-medium text-gray-700 mb-1.5" data-id="element-227">
        {label} {required && <span className="text-red-500" data-id="element-228">*</span>}
      </label>
      <div className="relative" data-id="element-229">
        {prefix && <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500" data-id="element-230">
            {prefix}
          </span>}
        <input id={id} type={type} value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} required={required} className={`w-full px-4 py-2.5 ${prefix ? 'pl-8' : ''} border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all ${error ? 'border-red-500' : ''}`} aria-invalid={error ? 'true' : 'false'} aria-describedby={error ? `${id}-error` : undefined} data-id="element-231" />
      </div>
      {error && <p id={`${id}-error`} className="mt-1 text-sm text-red-500" role="alert" data-id="element-232">
          {error}
        </p>}
    </div>;
}